/**
 * One widget per PropType (rule 4): the Inspector and Preferences render any
 * schema prop through this, with no knowledge of which component or setting
 * it belongs to. Adding a prop type means adding a widget here.
 */
import type { FunctionComponent } from "react";
import type { PropTypeName } from "../../world/schema/propTypes";
import { createArrayWidget } from "./ArrayWidget";
import { BoolWidget, EnumWidget } from "./ChoiceWidgets";
import { ColorWidget } from "./ColorWidget";
import { NumberWidget, Vec3Widget } from "./NumberWidgets";
import { AssetRefWidget } from "./AssetPicker";
import { ClipWidget } from "./ClipWidget";
import { EntityRefWidget } from "./RefWidgets";
import { StringWidget, TextWidget } from "./TextWidgets";
import type { WidgetProps } from "./types";
import { YearMonthWidget } from "./YearMonthWidget";
import "./widgets.css";

const WIDGETS: Readonly<Record<PropTypeName, FunctionComponent<WidgetProps>>> = {
  string: StringWidget,
  text: TextWidget,
  number: NumberWidget,
  bool: BoolWidget,
  vec3: Vec3Widget,
  color: ColorWidget,
  enum: EnumWidget,
  yearMonth: YearMonthWidget,
  array: createArrayWidget(PropWidget),
  assetRef: AssetRefWidget,
  entityRef: EntityRefWidget,
  clipRef: ClipWidget,
};

export function PropWidget(props: WidgetProps) {
  const Widget = WIDGETS[props.prop.type];
  return <Widget {...props} />;
}
